import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { IconButton } from '@totalsoft/rocket-ui';

const HeaderLinks = ({ onAdd }) => {
  const { t } = useTranslation();
  return <IconButton onClick={onAdd} type='add' fontSize='medium' color='transparent' tooltip={t('Tooltips.FinancialIndicators.Add')} />;
};

HeaderLinks.propTypes = {
  onAdd: PropTypes.func.isRequired
};

export default HeaderLinks;
